import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';

@extendDecorator({
    defaults: {
        selectedTabDate: null,
        operators: [],
        isExclusive: false,
        productType: 'all',
        meals: [],
        prepayments: [],
        bonusMiles: false,
    },
})
export default class HotelPageFilterCriteria extends Backbone.Epoxy.Model {
}